import React from "react";
import {Alert} from "reactstrap";
import PixQrModal from "../../../shared/components/PixQrModal";
import PixCodeModal from "./PixCodeModal";

/**
 * What came of the last copy (see useShare): a message, the Pix code in a
 * window when it has to be copied by hand, and the Pix QR code when asked for.
 * @param {{share: ReturnType<typeof import("./useShare").useShare>}} props
 */
const ShareNotice = ({share}) => (
    <>
        {share.notice && (
            <Alert color={share.notice.color} className="mb-3" toggle={share.dismissNotice}>
                {share.notice.content}
            </Alert>
        )}
        {share.pixCode && <PixCodeModal payload={share.pixCode} onClose={share.closePixCode} />}
        {share.qrCode && (
            <PixQrModal
                payload={share.qrCode}
                onClose={share.closeQrCode}
                hint="Peça ao cliente para ler com a câmera ou com o app do banco."
            />
        )}
    </>
);

export default ShareNotice;
